document.addEventListener('DOMContentLoaded', () => {
  if (!window.Swiper) return;

  const commonOptions = {
    loop: false,
    watchOverflow: true,
    grabCursor: true,
    passiveListeners: true,
    touchStartPreventDefault: false,
    preloadImages: false,
    lazy: { checkInView: true, loadOnTransitionStart: true }
  };

  const presets = {
    'swiper-slider-custom': (c) => ({
      slidesPerView: 1,
      breakpoints: {
        768: { slidesPerView: 3, spaceBetween: 30 },
        1024: { slidesPerView: 3, spaceBetween: 30 }
      },
      pagination: { el: c.querySelector('.hrz-slider-2-pagination'), clickable: true, type: 'bullets', dynamicBullets: true },
      navigation: { nextEl: c.querySelector('.hrz-slider-2-button-next'), prevEl: c.querySelector('.hrz-slider-2-button-prev') }
    })
  };

  const containers = document.querySelectorAll('.swiper');
  if (!containers.length) return;

  const io = new IntersectionObserver((entries) => {
    entries.forEach(({ isIntersecting, target }) => {
      if (!isIntersecting) return;
      initSwiperFor(target);
      io.unobserve(target);
    });
  }, { rootMargin: '400px' });

  containers.forEach(c => io.observe(c));

  function initSwiperFor(container) {
    let presetName = null;
    for (const name of Object.keys(presets)) {
      if (container.classList.contains(name)) { presetName = name; break; }
    }
    if (!presetName) return;

    if (presetName === 'hrz-galerie-2' && window.innerWidth >= 768) return;

    const presetFactory = presets[presetName];
    const presetConfig = typeof presetFactory === 'function' ? presetFactory(container) : presetFactory;

    if (presetConfig.pagination && !presetConfig.pagination.el) delete presetConfig.pagination;
    if (presetConfig.navigation && (!presetConfig.navigation.nextEl || !presetConfig.navigation.prevEl)) {
      delete presetConfig.navigation;
    }

    const config = {
      ...commonOptions,
      ...presetConfig,
      on: {
        init(sw) { updateRightmostSlide(sw); },
        slideChange(sw) { updateRightmostSlide(sw); },
        resize(sw) { updateRightmostSlide(sw); }
      }
    };

    // Init
    new Swiper(container, config);
  }

  let rafId = null;
  function updateRightmostSlide(swiper) {
    if (!swiper || !swiper.slides) return;
    if (rafId) cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(() => {
      swiper.slides.forEach(slide => slide.classList && slide.classList.remove('is-rightmost-slide'));

      let spv = swiper.params.slidesPerView;
      if (spv === 'auto' || typeof spv !== 'number') {
        spv = swiper.slidesPerViewDynamic ? swiper.slidesPerViewDynamic() : 1;
      } else {
        spv = Math.max(1, spv);
      }

      const idx = swiper.activeIndex + spv - 1;
      const slide = swiper.slides[idx];
      if (slide && slide.classList) slide.classList.add('is-rightmost-slide');
    });
  }
});
